"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamWithPlayersToJSON = exports.TeamWithPlayersFromJSONTyped = exports.TeamWithPlayersFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function TeamWithPlayersFromJSON(json) {
    return TeamWithPlayersFromJSONTyped(json, false);
}
exports.TeamWithPlayersFromJSON = TeamWithPlayersFromJSON;
function TeamWithPlayersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': json['_id'],
        'tournament': _1.TournamentFromJSON(json['tournament']),
        'name': json['name'],
        'startTime': json['startTime'],
        'startHole': json['startHole'],
        'identifier': !runtime_1.exists(json, 'identifier') ? undefined : json['identifier'],
        'teamHandicap': !runtime_1.exists(json, 'teamHandicap') ? undefined : json['teamHandicap'],
        'creationDate': json['creationDate'],
        'lastUpdated': json['lastUpdated'],
        'players': (json['players'].map(_1.PlayerFromJSON)),
    };
}
exports.TeamWithPlayersFromJSONTyped = TeamWithPlayersFromJSONTyped;
function TeamWithPlayersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'tournament': _1.TournamentToJSON(value.tournament),
        'name': value.name,
        'startTime': value.startTime,
        'startHole': value.startHole,
        'identifier': value.identifier,
        'teamHandicap': value.teamHandicap,
        'creationDate': value.creationDate,
        'lastUpdated': value.lastUpdated,
        'players': (value.players.map(_1.PlayerToJSON)),
    };
}
exports.TeamWithPlayersToJSON = TeamWithPlayersToJSON;
